import { useQuery, useQueryClient } from 'react-query';
import { Http } from '../../services/Http';
import { QUERY_KEYS } from '../constants';
import { User, UserRole } from '../../types';

async function fetchUserOperatingPartners(
  yearQueryParam: string,
  status?: string,
  role?: UserRole
): Promise<User[]> {
  let url = `/user/operating-partners?year=${yearQueryParam}`;
  if (status && status !== 'all') {
    url += `&status=${status}`;
  }
  if (role) {
    url += `&role=${encodeURIComponent(role)}`;
  }
  const { data } = await Http.axios.get<User[]>(url);
  return data;
}

export const useAllUserOperatingPartners = (yearQueryParam?: string, status?: string, role?: UserRole) => {
  const currentYear = new Date().getFullYear();
  yearQueryParam = yearQueryParam || String(currentYear);
  return useQuery(
    [QUERY_KEYS.USER_OPERATING_PARTNERS, yearQueryParam, status, role],
    () => fetchUserOperatingPartners(yearQueryParam as string, status, role),
    {
      staleTime: Infinity,
      retry: false,
      refetchInterval: false,
      refetchOnMount: true,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      refetchIntervalInBackground: false,
    }
  );
};

export const useInvalidateUserOperatingPartners = () => {
  const queryClient = useQueryClient();

  return () => {
    queryClient.invalidateQueries({
      queryKey: QUERY_KEYS.USER_OPERATING_PARTNERS,
    });
  };
};
